/*
 * @Author: edvardchen
 * @Date:   2016-11-11 16:01:37
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2017-05-25 16:31:02
 */

import React from 'react';
import PropTypes from 'prop-types';

import Media from '../Media';

// import withRoute from '../../HOCs/withRoute';
import withExposureWatch from '../../HOCs/withExposureWatch';

import styles from './index.scss';

const Item = withExposureWatch(Media);

export default function MediaList({ items, onItemCLick, onItemExposure }) {
  return (
    <ul>
      {items.map((item, index) => (
        <li key={index} className={`${styles.listItem} G-highlight`}>
          <Item {...item} onClick={onItemCLick} onExposure={onItemExposure} />
        </li>
      ))}
    </ul>
  );
}

MediaList.propTypes = {
  items: PropTypes.array,
  onItemCLick: PropTypes.func,
  onItemExposure: PropTypes.func,
};
